import React from 'react';
import PropTypes from 'prop-types';
import HeadshotComponent from '../headshot';
import moment from 'moment';

const JobPosting = ({ jobPosting, community, creator, toggleReplies }) => {

  const {
    id,
    title,
    subject,
    companySlug,
    companyName,
    companyLocation,
    createdAt
  } = jobPosting;

  return (
    <div className="message job-posting">
      <HeadshotComponent user={ creator } width={ 56 } />

      <div className="message-right">
        <p className="t5 w3 message-name">
          <a className="text-black" href={ creator.profileLink }>{ creator.displayName }</a>
          <span className="w2-5"> created a new job posting for </span>
          <a className="theme" href={ `/companies/${companySlug}` }>{ companyName }!</a>
        </p>

        <p className="t6 dark-gray" style={{ marginBottom: '-2px' }}>
          { creator.companyTitle.replace(' at ', ', ') }
        </p>

        <p className="t6 dark-gray" title={ createdAt }>
          { moment(createdAt).fromNow() }
        </p>
      </div>

      <div className="message-main pt-20">

        <div className="t5 content">
          <a className="nostyle" href={ `/jobs/${id}` }>
            <div className="module mb-0">
              <div className="module-header">
                <div className="t3 w3">{ title }</div>
                <div>{ companyLocation }</div>
              </div>
            </div>
          </a>
        </div>

      </div>
    </div>
  );
};

JobPosting.propTypes = {
};

export default JobPosting;
